import styled from 'styled-components';

export const DownloadZipLink = styled.button`
  color: var(--color-text-muted);
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 130%;
  font-family: 'General Sans', sans-serif;
  display: flex;
  margin-top: 12px;
  padding: 5px;

  span {
    margin-left: 5px;
  }
`;
